import { gql } from '@apollo/client';

const TABLE_FIELDS = `
  id
  schemaId
  schemaName
  tableName
  description
  purpose
  primaryKeyColumns
  keywords
  businessContext
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const CREATE_RELATIONSHIP = gql`
  mutation CreateTableRelationship($params: CreateRelationshipInput!) {
    createTableRelationship(params: $params) {
      success
      message
      errors
      data {
        id
        sourceTableId
        targetTableId
        targetTable {
          ${TABLE_FIELDS}
        }
        joinCondition
        relationshipType
        description
        businessContext
        isIdentifying
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_RELATIONSHIP = gql`
  mutation UpdateTableRelationship($params: UpdateRelationshipInput!) {
    updateTableRelationship(params: $params) {
      success
      message
      errors
      data {
        id
        sourceTableId
        targetTableId
        joinCondition
        relationshipType
        description
        businessContext
        isIdentifying
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_RELATIONSHIP = gql`
  mutation DeleteTableRelationship($params: DeleteRelationshipInput) {
    deleteTableRelationship(params: $params) {
      success
      message
      errors
    }
  }
`;
